(() => {
 const modal=document.createElement('dialog');
 modal.className='heary-review-dialog'; modal.setAttribute('aria-label','Customer review');
 const close=document.createElement('button'); close.type='button'; close.className='heary-review-close';close.textContent='Close review';
 const content=document.createElement('div'); modal.append(close,content); document.body.append(modal);
 let trigger;
 close.addEventListener('click',()=>modal.close());
 modal.addEventListener('close',()=>trigger?.focus({preventScroll:true}));
 modal.addEventListener('click',e=>{if(e.target===modal){const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)modal.close();}});
 function init(scope=document){
 scope.querySelectorAll('[data-review-card]').forEach(card=>{
 if(card.closest('[data-heary-reviews]'))return;
 if(card.dataset.expandReady)return;card.dataset.expandReady='true';
 const button=document.createElement('button');button.type='button';button.className='heary-review-expand';button.textContent='Read full review';
 const open=()=>{trigger=button;const copy=card.cloneNode(true);copy.hidden=false;copy.removeAttribute('tabindex');copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));copy.querySelectorAll('.heary-review-expand').forEach(el=>el.remove());copy.querySelectorAll('details').forEach(el=>el.open=true);content.replaceChildren(copy);modal.showModal();close.focus();};
 button.addEventListener('click',open);(card.querySelector('.thr-card-body')||card).append(button);
 card.addEventListener('click',e=>{if(!e.target.closest('button,a,summary,details,input'))open();});
 });
 }
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();